// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"k2-z","dimensionLabel":"l2-z","styleChooserControlWrapper":"m2-z","styleChooserControl":"n2-z","disabled":"o2-z","giftCard":"p2-z","styleChooserText":"q2-z"};